/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { Container, Button } from "@material-ui/core";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import TableToolbar from "../../../../components/Table/TableToolbar";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import EmailRoundedIcon from "@material-ui/icons/EmailRounded";
import moment from "moment-timezone";
import styles from "../../Report.module.scss"
import { getUserListBasedOnIds } from "../../../../services/apiservices/users";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import * as Excel from 'exceljs';
import { downloadPDF, downloadExcel } from "../../DownloadReportUtils";
import MultiSelectem from "../../../../components/SelectField/MultiSelectem";
import { getUserActivity } from "../../../../services/apiservices/activity";
import { Link, useNavigate } from "react-router-dom";
import ResponsiveTable from "../../../../components/ResponsiveCardComponent/ReportsComponent/EmployeeReports/ResponsiveEmpTable";
import { useMediaQuery } from "@mui/material";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import AuthContext from "../../../../hooks/authContext";
import ActionRender from "../../ActionRender";
import { getSettings } from "../../../../services/apiservices/settings";

function ActivityReport(props) {

    const csvHeaders = [
        "Employee Name",
        "Date",
        "Version Of the App(Device)",
        "Action"
    ];

    const [employeeList, setEmployeeList] = useState([]);

    const [employeeListMaster, setEmployeeListMaster] = useState([]);
    
    const [startDate, setStartDate] = useState(null);
    const [clientsListCSV, setClientListCSV] = useState([csvHeaders]);
    const [endDate, setEndDate] = useState(null);
    const [empName, setEmpName] = useState([]);
    const [settingsData, setSettingsData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [empNameList, setEmpNameList] = useState([]);
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:767px)');
    const isLandscape = useMediaQuery('(min-width: 771px) and (max-width: 940px)');
    const auth = useContext(AuthContext);
    const companyId = auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;

    const [detailedView, setDetailedView] = useState(null);
    const { setReportData } = auth || {};

    const getColumns = () => {
        const columns = [
            {
                id: "employeeName",
                numeric: false,
                disablePadding: false,
                label: "Name",
                isSortable: false,
            },
            {
                id: "date",
                numeric: false,
                disablePadding: false,
                label: "Date",
                isSortable: false,
            },
            {
                id: "version",
                numeric: false,
                disablePadding: false,
                label: "Version Of the App(Device)",
                isSortable: false,
            },
            {
                id: "actions",
                numeric: false,
                disablePadding: false,
                label: "Action",
                isSortable: false,
            },
            {
                id: "Action",
                numeric: false,
                disablePadding: false,
                label: "Actions",
                isSortable: false,
            },
        ];

        if (isMobile || isLandscape) {
            return columns.filter(col => col.id !== "employeeName" && col.id !== "date" && col.id !== "Action");
        }
        return columns;
    };

    const fetchInitialData = async () => {
      const [settingsRes] = await Promise.all([
        new Promise((resolve) =>
          getSettings("client_settings", companyId, (res) => resolve(res?.data))
        ),
      ]);
      const filteredData = settingsRes?.filter(
        (item) => !item.deleted
      );
      setSettingsData(filteredData?.length ? filteredData : []);
    };

    useEffect(() => {
      fetchInitialData();
    }, []);


    const getDatatoDownload = (rcellItem) => {
        let clientCSV = [];
        if (!Array.isArray(rcellItem)) {
            clientCSV = employeeList?.filter(
                (item) => item.employeNameId === rcellItem.employeNameId
            );
            clientCSV = clientCSV?.map((item) => {
                return [
                    item?.employeeName,
                    item?.date,
                    item?.version,
                    item?.actions
                ];
            });
        } else {
            clientCSV = rcellItem?.map((item) => {
                return [
                    item?.employeeName,
                    item?.date,
                    item?.version,
                    item?.actions
                ];
            });
        }
        return clientCSV;
    }

    const getDatatoFullDownload = (rcellItem) => {
        if (rcellItem) {
            employeeList?.filter(
                (item) => item.employeNameId === rcellItem.employeNameId
            );
            return [
                rcellItem?.employeeName,
                rcellItem?.date,
                rcellItem?.version,
                rcellItem?.actions
            ];
        } else {
            return [
                rcellItem?.employeeName,
                rcellItem?.date,
                rcellItem?.version,
                rcellItem?.actions
            ];
        }
    }

    const downloadForExcel = async (rcellItem, date, emailSend) => {
        let wb = new Excel.Workbook();
        let ws = wb.addWorksheet('Activity Report');
        const dates = (isMobile || isLandscape) ? `${moment(date).format("YYYY-MM-DD")}` : `${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;

        const clientCSV = getDatatoDownload(rcellItem);
        let fileName;
        if (Array.isArray(rcellItem)) {
            if (rcellItem.length === 1) {
                fileName = `ActivityReport_${rcellItem[0].employeeName}_${dates}`;
            } else {
                fileName = `ActivityReport_All_${moment(date).format("YYYY-MM-DD")}`;
            }
        } else {
            fileName = `ActivityReport_${rcellItem.employeeName}_${dates}`;
        }
        let name = true;
        return await downloadExcel(clientCSV, csvHeaders, wb, ws, fileName, emailSend, name)
    }

    const downloadForPDF = async (rcellItem, date, emailSend) => {
        const clientCSV = getDatatoDownload(rcellItem);
        const dates = (isMobile || isLandscape) ? `${moment(date).format("YYYY-MM-DD")}` : `${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
        let fileName;
        if (Array.isArray(rcellItem)) {
            if (rcellItem.length === 1) {
                fileName = `ActivityReport_${rcellItem[0].employeeName}_${dates}`;
            } else {
                fileName = `ActivityReport_All_${moment(date).format("YYYY-MM-DD")}`;
            }
        } else {
            fileName = `ActivityReport_${rcellItem.employeeName}_${dates}`;
        }
        let name = true;
        const logo = settingsData?.[0]?.companyLogo;
        return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend, name);
    }

    const setDownloadCSVData = (event, done, rcellItem, date) => {
        const clientCSV = getDatatoDownload(rcellItem);

        const reportName = "Activity Report";

        const employeName = Array.isArray(rcellItem) ? rcellItem.length === 1 ? `${rcellItem[0].employeeName}`
            : `All` : `${rcellItem.employeeName}`;
        const reportPeriod = (isMobile || isLandscape) ? `${moment(date).format("YYYY-MM-DD")}`
            : `${moment(startDate).format("YYYY-MM-DD")} to ${moment(endDate).format("YYYY-MM-DD")}`;
        // Create the report details rows
        const reportDetails = [
            [`Employee Name: ${employeName}`],
            [`Report Name: ${reportName}`],
            [`Report Period: ${reportPeriod}`],
            [],
            [...csvHeaders],
            ...clientCSV
        ];
        // Set the CSV data
        setClientListCSV(reportDetails);
        done();
    };


    const downloadForFullPDF = async (emailSend) => {
        const clientCSV = employeeList.map((item) => getDatatoFullDownload(item));
        let empNamefordwonLoad = 'All'
        if (empName.length !== 0 && empName.length !== empNameList.length) {
            // Extracting labels
            const names = empNameList.filter((item) => empName.includes(item.value)).map((emp) => emp.label);
            empNamefordwonLoad = names.join(', ');
        } else if (empName.length === 0) {
            empNamefordwonLoad = 'All'
        }
        let fileName = `ActivityReport_${empNamefordwonLoad}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`
        let name = true;
        const logo = settingsData?.[0]?.companyLogo;
        return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend, name);
    }

    const downloadForFullExcel = async (emailSend) => {
        let wb = new Excel.Workbook();
        let ws = wb.addWorksheet('Activity Report');
        let empNamefordwonLoad = 'All'

        const clientCSV = employeeList.map((item) => getDatatoFullDownload(item));

        if (empName !== 'All') {
            const names = empNameList.filter((item) => empName.includes(item.value)).map((emp) => emp.label);
            empNamefordwonLoad = names.join(', ');
        }
        let fileName = `ActivityReport_${empNamefordwonLoad}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`
        let name = true;
        return await downloadExcel(clientCSV, csvHeaders, wb, ws, fileName, emailSend, name)
    }

    const handleEmailIconClick = async (rcellItem, date) => {
      const emailSend = true;
      let name;
        if (Array.isArray(rcellItem)) {
            if (rcellItem.length === 1) {
                name = rcellItem[0]?.employeeName;
            } else {
                name = 'All';
            }
        } else {
            name = rcellItem?.employeeName;
        }

      const Dates = (isMobile || isLandscape) ? `${moment(date).format("YYYY-MM-DD")}` : `${startDate}`;

      const [excelBlob, pdfBlob] = await Promise.all([
        downloadForExcel(rcellItem, date,  emailSend),
        downloadForPDF(rcellItem, date, emailSend)
      ]);
      // Convert the Excel blob to a base64-encoded string
      const reader = new FileReader();
      reader.readAsDataURL(excelBlob);
      reader.onloadend = function () {
        const base64Data = reader.result;
        setReportData((prev) => ({
          ...prev,
          FileName: "ActivityReport",
          ReportsName: "Employee Report",
          Name: name,
          Date: Dates,
          EndDate: endDate,
          pdf: pdfBlob,
          storedData: base64Data,
          fullData: "",
          fullExcelData: ""
        }));
        navigate("/emailreports");
      };
    };

    const handelEmailFullReport = async () => {
      const emailSend = true;

      let empNamefordwonLoad = 'All'

      if (empName.length !== 0 && empName.length !== empNameList.length) {
        // Extracting labels
        const names = empNameList?.filter((item) => empName.includes(item.value))?.map((emp) => emp?.label);
        empNamefordwonLoad = names.join(', ');
      }

      const [fullReport, fullExcelReport] = await Promise.all([
        downloadForFullPDF(emailSend),
        downloadForFullExcel(emailSend)
      ]);
      const reader = new FileReader();
      reader.readAsDataURL(fullExcelReport);
      reader.onloadend = function () {
        const base64Data = reader.result;
        setReportData((prev) => ({
        ...prev,
          FileName: "ActivityReport",
          ReportsName: "Employee Report",
          Name: empNamefordwonLoad,
          Date: startDate,
          EndDate: endDate,
          fullData: fullReport,
          fullExcelData: base64Data,
          pdf: "",
          storedData: ""
        }));
        navigate("/emailreports");
      }
    }

    const handlePdfClick = async (records, date, emailSend) => {
        await downloadForPDF(records, date, emailSend);
    }

    const handleExcelClick = async (records, date, emailSend) => {
        await downloadForExcel(records, date, emailSend);
    }

    const handleCSvClick = async (event, done, records, date) => {
        await setDownloadCSVData(event, done, records, date);
    };

    const handelEmailClicks = async (records, date) => {
        await handleEmailIconClick(records, date);
    }
    const handleEmpNameChange = (e) => {
        setEmpName(e);
        setEmployeeList(() =>
            employeeListMaster.filter((itme) => {
                let returnFlg = true;
                if (returnFlg) {
                    returnFlg = e.includes(itme.employeNameId);
                }
                return returnFlg;
            })
        );
    };

    useEffect(() => {
        if (startDate && endDate) {
        getReportListData(startDate, endDate);
        }
    }, [startDate, endDate]);


    const mapWidhtEmpList = (userIds, timeSheet) => {
        getUserListBasedOnIds(userIds, async (result) => {
            try {
                const employeeRoles = result?.filter(item => item.role === "Employee" && item.companyId === companyId);
                const employee = employeeRoles?.map(item => ({
                    value: item.id,
                    label: `${item.firstName} ${item.lastName}`
                }));
                setEmpNameList([...employee]);
    
                const userDataToUpdate = timeSheet
                    .filter(data => employee.some(emp => emp.value === data.userId))
                    .sort((a, b) => a.createdOn.seconds - b.createdOn.seconds);
                const userDataMap = {};
                userDataToUpdate.forEach(item => {
                    if (!userDataMap[item.userId]) {
                        userDataMap[item.userId] = [];
                    }
    
                    const user = result.find(u => u.id === item.userId);
                    const userTimeZone = user?.timeZone || "America/New_York"; 
                    
                    if (item.createdOn?.seconds) {
                        const date = moment.unix(item.createdOn.seconds).tz(userTimeZone).format('ll');
                        const timeFormats = moment.unix(item.createdOn.seconds).tz(userTimeZone).format("hh:mm A");
                        const actions = `${item.type} (${timeFormats})`;
    
                        userDataMap[item.userId].push({
                            date: date,
                            version: item.version 
                                ? `${item.version} (${parseFloat(item.version) < 0 ? 'Web' : item.device || ''})` 
                                : '---',
                            actions: actions
                        });
                    } else {
                        console.warn("Missing createdOn field in timesheet data:", item);
                    }
                });

                const employeeListMaster = [];
                for (const userId in userDataMap) {
                    const user = result?.find(item => item.id === userId);
                    if (user) {
                        const userActivities = userDataMap[userId].map(activity => ({
                            employeeName: `${user.firstName} ${user.lastName}`,
                            employeNameId: userId,
                            date: activity.date,
                            version: activity.version,
                            actions: activity.actions
                        }));
                        employeeListMaster.push(...userActivities);
                    }
                }
    
                const sortedData = sortingFunction(employeeListMaster);
                setEmployeeListMaster(sortedData);
                setEmployeeList(
                    sortedData.filter(item => empName.length > 0 ? empName.includes(item.employeNameId) : true)
                );
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        });
    };

    const sortingFunction = (data) => {
        const result = data.sort((a, b) => {
            if (a.employeeName < b.employeeName) return -1;
            if (a.employeeName > b.employeeName) return 1;

            // Parse the date strings into Date objects for correct comparison
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);

            if (dateA < dateB) return -1;
            if (dateA > dateB) return 1;

            return 0;
        });

        return result;
    };

    const getUniqueUserIds = (activityData) => {
        const userIds = new Set();
        
        activityData.forEach(item => {
            userIds.add(item.userId);
        });
        
        return Array.from(userIds);
    };

    const getReportListData = async (startDt, endDt) => {
        const startDate = `${dayjs(startDt).format("YYYY-MM-DD")}T00:00:00`;
        const endDate = `${dayjs(endDt).format("YYYY-MM-DD")}T23:59:59`;
    
        try {
            const data = await getUserActivity(companyId, empName);
            const details = data?.filter((item)=> item.companyId === companyId);
            const ActivityData = details?.filter(item => {
                const itemCreatedOn = new Date(item.createdOn.seconds * 1000);
                const start = new Date(startDate);
                const end = new Date(endDate);
                return itemCreatedOn >= start && itemCreatedOn <= end;
            });
    
            const ids = getUniqueUserIds(ActivityData);
            mapWidhtEmpList(ids, ActivityData);
        } catch (error) {
            console.error("Error fetching report list data:", error);
        }
    };


    const renderRowCell = (rcellItem, hcellItem, index, rowindex, isMobile, isLandscape) => {
        switch (hcellItem.id) {
            case "employeeName":
                // if (isMobile || isLandscape) {
                //     return null;
                // }
                if (
                    rowindex !== 0 &&
                    employeeList[rowindex - 1].employeeName !== rcellItem.employeeName
                ) {
                    return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
                } else if (rowindex === 0) {
                    return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
                } else {
                    return "";
                }
            case "Action":
                if (isMobile || isLandscape) {
                    if (rowindex === 0) {
                        return (
                            <ActionRender
                                rcellItem={rcellItem}
                                clientsListCSV={clientsListCSV}
                                setDownloadCSVData={setDownloadCSVData}
                                downloadPDF={downloadForPDF}
                                downloadExcel={downloadForExcel}
                                startDate={startDate}
                                endDate={endDate}
                                handleEmailIconClick={handleEmailIconClick}
                                name={"ActivityReport"}
                            />
                        );
                    } else {
                        return null;
                    }
                } else {
                    if (
                        rowindex !== 0 &&
                        employeeList[rowindex - 1].employeNameId !== rcellItem.employeNameId
                    ) {
                        return (
                            <ActionRender
                                rcellItem={rcellItem}
                                clientsListCSV={clientsListCSV}
                                setDownloadCSVData={setDownloadCSVData}
                                downloadPDF={downloadForPDF}
                                downloadExcel={downloadForExcel}
                                startDate={startDate}
                                endDate={endDate}
                                handleEmailIconClick={handleEmailIconClick}
                                name={"ActivityReport"}
                            />
                        );
                    } else if (rowindex === 0) {
                        return (
                            <ActionRender
                                rcellItem={rcellItem}
                                clientsListCSV={clientsListCSV}
                                setDownloadCSVData={setDownloadCSVData}
                                downloadPDF={downloadForPDF}
                                downloadExcel={downloadForExcel}
                                startDate={startDate}
                                endDate={endDate}
                                handleEmailIconClick={handleEmailIconClick}
                                name={"ActivityReport"}
                            />
                        );
                    } else {
                        return "";
                    }
                }
            default:
                return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
        }
    };

    const tableRightComponent = () => {
        return (
            <div className="d-flex w320 editEmp issueAlign pl-8">
                <div className="mr-24 d-flex flex-center"> <FilterAltIcon className="mv-7 issueicon" /> <span> Filters </span> </div>
                <div className="reportsMargin mv-7">
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                            label="Start Date"
                            className="customDate customDatePicker dark:[&_.MuiInputBase-input]:text-white dark:[&_.MuiInputLabel-root]:text-white"
                            value={startDate}
                            onChange={(newValue) => {
                                setStartDate(newValue);
                                // if (newValue) {
                                //     setEndDate(moment());
                                // } else {
                                //     setEndDate(null);
                                // }
                            }}
                            maxDate={moment()}
                            views={['year', 'month', 'day']}
                            inputFormat="YYYY-MM-DD"
                        />
                    </LocalizationProvider>
                </div>
                <div className="reportsMargin mv-7">
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                            label="End Date"
                            className="customDate customDatePicker dark:[&_.MuiInputBase-input]:text-white dark:[&_.MuiInputLabel-root]:text-white"
                            value={endDate}
                            onChange={(newValue) => {
                                setEndDate(newValue);
                                // if (!newValue) {
                                //     setStartDate(null);
                                // }
                            }}
                            maxDate={moment()}
                            views={['year', 'month', 'day']}
                            inputFormat="YYYY-MM-DD"
                        />
                    </LocalizationProvider>
                </div>
                <div className="reportsMargin mv-7">
                    <MultiSelectem
                        value={empName}
                        className={`field  ${styles.ddminWidth} `}
                        name={"employeeName"}
                        label={"Employee Name"}
                        onChange={handleEmpNameChange}
                        options={empNameList}
                    />
                </div>
            </div>
        );
    };

    return (
        <>
            <Container>
                <PageTitle
                    pageTitle="Activity Reports"
                    showBreadcrumb={[
                        { label: "Home", to: "/" },
                        { label: "Reports" },
                        { label: "Employee Reports", to: "/reports/Employeereport" }
                    ]}
                    BreadCrumbCurrentPageTitle={"Activity Reports"}
                    showLastSeen={true}
                ></PageTitle>

                <div className="sectionBox2 dark:bg-[#1A1F2C] dark:text-white shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
                    {!detailedView && (
                        <TableToolbar
                            rightComponent={tableRightComponent()}
                        />
                    )}
                    <ResponsiveTable
                        rows={employeeList}
                        getColumns={getColumns}
                        hidePagination={true}
                        isLoading={isLoading}
                        renderRowCell={renderRowCell}
                        detailedView={detailedView}
                        setDetailedView={setDetailedView}
                        fileName={"Activity Report"}
                        onClickPdf={handlePdfClick}
                        onClickExcel={handleExcelClick}
                        onClickCsv={handleCSvClick}
                        clientsListCSV={clientsListCSV}
                        onClickEmail={handelEmailClicks}
                    />
                </div>

                {!detailedView && (
                    <div className={styles.report}>
                        <div className={styles.download1}>
                            <EmailRoundedIcon />
                            <div>
                                <Link to={employeeList.length !== 0 && "/emailreports"} rel="noopener" >
                                    <Button
                                        className={styles.actions}
                                        disabled={employeeList.length === 0}
                                        onClick={() => {
                                            handelEmailFullReport()
                                        }}
                                    >
                                        Full Report
                                    </Button>
                                </Link>
                            </div>
                        </div>
                        <div className={styles.download1}>
                            <PictureAsPdfIcon />
                            <div>
                                <Button
                                    className={styles.actions}
                                    disabled={employeeList.length === 0}
                                    onClick={() => {
                                        downloadForFullPDF();
                                    }}
                                >
                                    Download Full Report
                                </Button>
                            </div>
                        </div>
                    </div>
                )}
            </Container>
        </>
    );
}

export default ActivityReport;
